import { useBunja } from 'bunja/react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { FormattedMessage } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';

import { entryPopupBlockBunja, entryPopupItemBunja } from '../../bunja';
import AffiliateDashboardImg from './img_affiliate_dashboard.webp';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
}

export const AffiliateDashboardRenewalModal = ({ isOpen, onClose, onExit }: Props) => {
  const t = useTranslations();
  const router = useRouter();
  const { popup, markAsRead } = useBunja(entryPopupItemBunja);
  const { block } = useBunja(entryPopupBlockBunja);

  if (popup.id !== 'NEW_AFFILIATE_DASHBOARD') throw new Error('Popup ID mismatch');

  return (
    <Modal isOpen={isOpen} css={{ width: 'auto' }} onExit={onExit}>
      <Modal.Close
        onClose={() => {
          markAsRead(popup.id);
          onClose();
        }}
      />
      <Modal.Header>
        <Modal.Title label={t('Autogen_common.r251126.s_Your_Affiliate_Dashboard_has_been_upgraded')} />
        <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>
          <FormattedMessage id='Autogen_common.r251126.s_View_detailed_reward_data_by_period_and_referee_gain_insights_and_grow_your_earnings_with_confidence' />
        </p>
      </Modal.Header>
      <Modal.Content>
        <Image
          src={AffiliateDashboardImg}
          alt='affiliate dashboard'
          width={736}
          height={538}
          className={css({ maxW: '100%', height: 'auto' })}
          priority
        />
      </Modal.Content>
      <Modal.Footer css={{ pb: 32, pt: 0 }}>
        <Button
          hierarchy='primary'
          color='accent'
          size='large'
          label={t('Autogen_common.r251126.s_Explore_new_dashboard')}
          onClick={() => {
            router.push(`/support/affiliate`);
            block('NEW_AFFILIATE_DASHBOARD');
            onClose();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};
